/**
 * Describes a customer, either organisation or human
 */
export interface Customer {
  customerCode: string;
  customerDesc: string;
  customerId?: number;
  customerSegment?: CustomerSegment;
  userId?: number;
  countryCode?: string;
}

/**
 * Purpose unknown, update from API docs when they are written and/or provided.
 */
export interface CustomerSegment {
  customerSegmentCode: string;
  customerSegmentDesc: string;
  customerSegmentId: number;
}

/**
 * A user of the application, with contact details
 */
export interface UserProfile {
  allowEmailUpdates: number; // TODO
  /**
   * May indicate GDPR permissions - clarify using API docs
   */
  allowInformationShare: number; // TODO
  customerId: number;
  firstName: string;
  lastName: string;
  fullName: string;
  phoneNumber: string;
  status: string; // TODO
  userPosition: string;
  userType: string; // TODO
  userAccount: string;
}
